import React, {useState} from 'react'
import {clearSalesNotification} from 'redux/actions'
import {connect} from "react-redux";
import Endpoints from "../../../constants/Endpoints";
import {makeStyles} from "@material-ui/core/styles";
import {Box, Dialog, DialogContent, DialogTitle, Typography} from "@material-ui/core";
import Loading from "../../Loading";
import SalesService from "../../../services/SalesService";
import IconCloseButton from "../../button/IconCloseButton";
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import Tr from 'translations/Translations';

const useStyle = makeStyles((theme => ({
    paper: {
        width: 688,
        maxWidth: 688,
        minWidth: 688
    },
    content: {
        position: 'relative',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        paddingTop: 0
    },
    img: {
        width: 640
    },
    click: {
        position: 'absolute',
        height: 62,
        width: 438,
        top: 217,
        left: 51,
        cursor: 'pointer'
    },
    loading: {
        position: 'absolute',
        left: 0,
        top: 0,
        margin: 0,
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
    }, closeButtonBox: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    closeButton: {
        color: theme.palette.primary.main,
    },
    icon: theme.components.icon,
    confirmationMessage: {
        marginBottom: theme.spacing(10),
        marginTop: theme.spacing(4),
        fontWeight: theme.typography.fontWeightBold,
    }
})));

function SalesNotificationPopup(
    {
        salesNotification,
        clearSalesNotification,
    }) {

    const [working, setWorking] = useState(false);
    const [processed, setProcessed] = useState(false);

    const classes = useStyle();
    const handleCloseDialog = () => {
        setProcessed(false);
        clearSalesNotification();
    }

    const sendNotification = () => {
        setWorking(true);
        SalesService.notificationSend(salesNotification).finally(() => {
            setWorking(false);
            setProcessed(true);
        });
    }


    return (<Dialog
        classes={{
            paper: classes.paper
        }}
        open={!!salesNotification}
        onClose={handleCloseDialog}
    >
        <DialogTitle>
            &nbsp;
            <Box className={classes.closeButtonBox}>
                <IconCloseButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={handleCloseDialog}
                />
            </Box>
        </DialogTitle>
        <DialogContent classes={{root: classes.content}}>
            {salesNotification && !processed &&
            <>
                <img className={classes.img} src={`${Endpoints.SERVER_URL}/pic/images/sales_notification_${salesNotification}.jpg`} alt={salesNotification}/>
                <span className={classes.click} onClick={sendNotification}></span>
            </>}
            {salesNotification && processed &&
            <>
                <DoneOutlineIcon className={classes.icon} color='primary'/>
                <Typography className={classes.confirmationMessage}>{Tr('sales_notification_confirmation_message')}</Typography>
            </>}
            {working && <Loading className={classes.loading}/>}
        </DialogContent>
    </Dialog>)
}

export default connect((state) => ({
    salesNotification: state.store.salesNotification
}), {
    clearSalesNotification
})(SalesNotificationPopup);